import { render } from "./homeResourceCentre.vue?vue&type=template&id=638ce36c&scoped=true"
import script from "./homeResourceCentre.vue?vue&type=script&lang=js"
export * from "./homeResourceCentre.vue?vue&type=script&lang=js"

import "./homeResourceCentre.vue?vue&type=style&index=0&id=638ce36c&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638ce36c"]])

export default __exports__